import BaseBlockContent from '@sanity/block-content-to-react';
import ClassNameWrapper from './serializers/ClassNameWrapper';
import Figure from './serializers/Figure';
import Iframe from './serializers/Iframe';
import Link from 'next/link';
import ListItem from './serializers/ListItem';
import PropTypes from 'prop-types';
import SideBySide from './serializers/SideBySide';
import TableHardcoded from './serializers/TableHardcoded';
import prepInternalUrl from '@/lib/prepInternalUrl';

const serializers = {
  types: {
    block(props) {
      switch (props.node.style) {
        case 'h1':
          return <h1>{props.children}</h1>;

        case 'h2': {
          return <h2>{props.children}</h2>;
        }

        case 'h3':
          return <h3>{props.children}</h3>;

        case 'h4':
          return <h4>{props.children}</h4>;

        case 'h5':
          return <h5>{props.children}</h5>;

        case 'blockquote':
          return (
            <blockquote>
              <p>{props.children}</p>
            </blockquote>
          );

        default:
          return <p>{props.children}</p>;
      }
    },
    figure(props) {
      return <Figure {...props.node} />;
    },
    tableHardcoded(props) {
      return <TableHardcoded {...props.node} />;
    },
    iframe(props) {
      return <Iframe {...props.node} />;
    },
    sideBySide(props) {
      return <SideBySide {...props.node} />;
    },
    jumpName(props) {
      return <div id={props.node.id} />;
    },
    classNameWrapper(props) {
      return <ClassNameWrapper {...props.node} />;
    },
  },
  marks: {
    internalLink: ({ mark, children }) => {
      const { href, blank } = mark;
      if (typeof href !== 'string' || !href.trim()) {
        return <span>{children}</span>;
      }
      return (
        <Link href={prepInternalUrl(href)} target={blank ? '_blank' : '_self'}>
          {children}
        </Link>
      );
    },
    link: ({ mark, children }) => {
      const { blank, href } = mark;
      if (typeof href !== 'string' || !href.trim()) {
        return <span>{children}</span>;
      }
      return blank ? (
        <a href={href} target="_blank" rel="noopener noreferrer">
          {children}
        </a>
      ) : (
        <a href={href}>{children}</a>
      );
    },
    jumpLink: ({ mark, children }) => {
      const { id } = mark;
      if (typeof id !== 'string' || !id.trim()) {
        return <span>{children}</span>;
      }
      return <a href={`#${id}`}>{children}</a>;
    },
  },
  listItem: (props) => {
    return <ListItem {...props} />;
  },
};

const Content = ({ content }) => (content ? <BaseBlockContent blocks={content} serializers={serializers} /> : null);

Content.propTypes = {
  content: PropTypes.array,
};

export default Content;
